export class AuthorizationError extends Error {
  readonly name = "AuthorizationError";

  // constructor(message?: string) {
  //   super(message);
  // }
}